import type { CardPreviewProps } from "@/components/shapes/card-previews";
import { frameDisplayTitle } from "@/lib/frame-display-title";
import { PreviewBody, PreviewTitle } from "./card-preview-parts";
import { frameStaticExcerpt } from "./frame-static-excerpt";

/**
 * Every type without its own preview: the title and a plain-text excerpt
 * that keeps its paragraphs on their own lines.
 */
export function GenericCardPreview({
  frame,
  source,
  density,
}: CardPreviewProps) {
  const excerpt = frameStaticExcerpt(frame.frameType, source);
  return (
    <PreviewBody density={density}>
      <PreviewTitle>{frameDisplayTitle(frame)}</PreviewTitle>
      {excerpt && (
        <p
          className="line-clamp-6 min-h-0 whitespace-pre-line leading-[1.55] text-card-body"
          data-testid="card-preview-excerpt"
        >
          {excerpt}
        </p>
      )}
    </PreviewBody>
  );
}
